(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/assets/hooks/use-mobile-keyboard-detect.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/assets/hooks/use-mobile-keyboard-detect.js');

'use strict';

const {
  useEffect,
  useState
} = React;
const useMobileKeyboardDetect = () => {
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      let keyboardOpen = false;
      const currentHeight = window.innerHeight;
      const screenHeight = window.screen.height;
      const activeElement = document.activeElement;
      const {
        isSelfService
      } = svs.core.config.data.svsconfig;
      const isNativeApp = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp', window) && svs.core.config.data.svsconfig.isNativeApp;
      const isInputFocused = activeElement && (activeElement.tagName === 'INPUT' && activeElement.id === 'lyckoplatsenName' || activeElement.tagName === 'TEXTAREA');
      if (isNativeApp) {
        keyboardOpen = isNativeApp && isInputFocused && currentHeight < screenHeight * 0.80;
      }
      if (isSelfService) {
        keyboardOpen = isSelfService && isInputFocused;
      }
      setIsKeyboardVisible(keyboardOpen);
    };
    window.addEventListener('resize', handleResize);

    window.addEventListener('focus', handleResize, true);
    window.addEventListener('blur', handleResize, true);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('focus', handleResize, true);
      window.removeEventListener('blur', handleResize, true);
    };
  }, []);
  return isKeyboardVisible;
};
Object.assign(svs.lyckoplatsen.hooks, {
  useMobileKeyboardDetect
});

 })(window);